import { APIProvider } from "@vis.gl/react-google-maps";
const API_KEY = "AIzaSyAI4DA5bDBH2m1d-OrGsLFWlHTym2aX-Oc";

type GoogleMapsProviderProps = {
  children: React.ReactNode;
};

export function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  return (
    <APIProvider
      apiKey={API_KEY}
      libraries={["places", "maps", "geometry", "drawing"]}
      onLoad={() => {
        console.log("Google Maps API loaded successfully.");
      }}
      onError={(error) => {
        console.error("Error loading Google Maps API:", error);
      }}
    >
      {children}
    </APIProvider>
  );
}
